// extracted by mini-css-extract-plugin
export var component = "WastePickupSearchResults-module--component--p2-bV";
export var empty = "WastePickupSearchResults-module--empty--3jHIj";
export var list = "WastePickupSearchResults-module--list--UzUm4";